import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../../cp/js/utils-service";
import Swal from "sweetalert2";

export class ModOfferWarrantyRefund extends ModuleComponent{
    ready(){
        super.ready();
        const $offerid = this.findMember("buttons").data("id");
        const $key = this.$root.data("key");
        this.findMember("accept").click(
            (ev) => {
                Swal.fire({
                    title: "¿Aceptar la devolución de la garantía adicional?",
                    text: "Procederemos a devolver el importe pagado por el inquilino",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#0A93D5",
                    cancelButtonColor: "#333",
                    confirmButtonText: "Devolver garantía adicional",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if(result.isConfirmed){
                        GvfService.endpoint(
                            "/web/offer-warranty-refund/accept-refund",
                            {key: $key, offerId: $offerid}
                        ).then(
                            (resp) => {
                                Swal.fire({
                                    title: resp.message,
                                    text: resp.description,
                                    icon: "success",
                                    confirmButtonText: "OK",
                                    didClose: () => {
                                        window.location.reload();
                                    }
                                });
                            }
                        ).catch(UtilsService.alertEndpointResponse);
                    }
                });
            }
        );

        this.findMember("reject").click(
            (ev) => {
                Swal.fire({
                    title: "¿Rechazar la devolución de la garantía adicional?",
                    text: "No se devolverá ningún importe al inquilino",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#0A93D5",
                    cancelButtonColor: "#333",
                    confirmButtonText: "Rechazar devolución",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if(result.isConfirmed){
                        GvfService.endpoint(
                            "/web/offer-warranty-refund/reject-refund",
                            {key: $key, offerId: $offerid}
                        ).then(
                            (resp) => {
                                Swal.fire({
                                    title: resp.message,
                                    text: resp.description,
                                    icon: "success",
                                    confirmButtonText: "OK",
                                    didClose: () => {
                                        window.location.reload();
                                    }
                                });
                            }
                        ).catch(UtilsService.alertEndpointResponse);
                    }
                });
            }
        );
    }
}
